import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13c53c61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Wunderbar!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Du hast alle Gegenstände für das neue Museum gefunden. Der Museumsdirektor ist dir sehr dankbar! Als kleines Dankeschön hat er für dich eine süsse Überraschung!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Hole deine Überraschung mit diesem Bildschirm an der Inselbar ab!")
], -1))

import {computed, inject, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import Confetti from "@/components/functional/Confetti.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()

const gamehandler: any = inject('gamehandler')
const party = ref<boolean>(false)
let requiredObjectsCount = computed<number>(() => {
  return store.getters['getRequiredObjectCount']
})

let newGame = (): void => {
  gamehandler.resetCollection()
  next()
}
let next = () => {
  router.push('/')
}
let checkIfGameWasPlayed = () => {
  const numberOfFoundItems: number = gamehandler.countCollection()
  if(numberOfFoundItems !== requiredObjectsCount.value || requiredObjectsCount.value === 0){
    next()
  }
}

onMounted(() => {
  checkIfGameWasPlayed()
  party.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "color-bg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(newGame) && _unref(newGame)(...args)))
      }, "Nochmals spielen")
    ]),
    (party.value)
      ? (_openBlock(), _createBlock(Confetti, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})